import React, { useEffect } from 'react';

import styled from '@emotion/styled';

import StatusCell from '../../../components/Badge/StatusCell';
import BAVerificationStatsCard from '../../../components/Cards/BAVerificationStatsCard';
import BADriverInfoIcon from '../../../components/Icons/BADriverInfoIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableFirstAndLastNameFormatter from '../../../components/Table/TableAccessories/TableFirstAndLastNameFormatter';
import TableListSizeCounterFormatter from '../../../components/Table/TableAccessories/TableListSizeCounterFormatter';
import TablePhoneFormatter from '../../../components/Table/TableAccessories/TablePhoneFormatter';
import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
import BAFilterForm from '../../../components/Table/TableFilterForms/BAFilterForm';
import ViewBADriverInfoCell from '../../../components/Table/TableMobileRowCell/ViewBADriverInfoCell';
import ViewBADriverInfo from '../../../components/Table/TableSliderViews/ViewBADriverInfo';
import useBaVerificationStatsCard from '../../../hooks/dashboard/BaDriverVerification/useBaVerificationStatsCard';
import ExportBaData from '../DemoRequests/ExportBaData';

const BADriverVerificationSuperAdmin = () => {
  const { getBaVerificationStats } = useBaVerificationStatsCard();

  useEffect(() => {
    getBaVerificationStats();
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver Verification'>
      <PageLayout noTitle={true}>
        <Container>
          <CardTitle>OVERVIEW</CardTitle>

          <BAVerificationStatsCard />

          <Table
            tableTitle='DRIVER INFO LIST'
            tableFilterBoxFeatures={{
              showSearchBox: true,
              searchBoxPlaceholder: 'Search',
              rightAttr: [
                {
                  type: 'filter',
                  comp: <BAFilterForm />,
                },
                {
                  type: 'regular',
                  comp: <ExportBaData />,
                },
              ],
            }}
            tableHeader={{
              'BA Name': 'userName',
              'Date Uploaded': 'createdAt',
              'Driver Name': 'firstName',
              'Phone No.': 'phoneNumber',
              // NIN: 'nin',
              // DOB: 'dateOfBirth',
              'No. of Vehicles Operated': 'fleetTypes',
              'Processing Status': 'status',
            }}
            tableDataSourceUrl='ba/v1/drivers/onboarding/get-paged-drivers'
            cellsCustomComp={{
              phoneNumber: <TablePhoneFormatter dataKey='phoneNumber' />,
              createdAt: <TableDateFormatter dataKey='createdAt' />,
              status: <StatusCell statusKey='status' hasDot />,
              fleetTypes: (
                <TableListSizeCounterFormatter dataKey='fleetTypes' />
              ),
              firstName: (
                <TableFirstAndLastNameFormatter
                  firstNameDataKey='firstName'
                  lastNameDataKey='lastName'
                />
              ),
            }}
            moreOptionsComponents={[
              <ViewDetails
                key='View driver profile'
                label='View driver profile'
                width='200px'
                icon={<BADriverInfoIcon />}
                sliderCompFn={(data: any) => <ViewBADriverInfo data={data} />}
              />,
            ]}
            mobileCellComp={<ViewBADriverInfoCell />}
          />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default BADriverVerificationSuperAdmin;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const CardTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 16px;
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
